import type { JSX } from 'react'
import type { IFallbackImageProps } from 'atoms/FallbackImage'
import type { IDescriptionProps } from 'blocks/Description'
import type { ILabelGroupTemplate3Props } from 'blocks/LabelGroup/Templates'

import {
  TextBoxBody3Disable,
  TextBoxMaxLine1FontLgBold,
} from 'atoms/TextBox/Templates'
import { Description, DescriptionRowGap } from 'blocks/Description'
import { InfoBlockDescriptionSC } from 'blocks/Description/Description.styled'
import { LabelGroupTemplate3 } from 'blocks/LabelGroup/Templates'
import {
  TextBlockWithLogo,
  TextBlockWithMore,
} from 'blocks/TextBlock/Templates'
import {
  infoBlockEPGDescriptionBlockMore,
  infoBlockEPGDescriptionTitle,
} from 'utils/constants'
import { getValueForBreakpoint } from 'utils/helpers'
import { useClientWidth } from 'utils/hooks'

export interface IInfoBlockEPG extends Omit<IDescriptionProps, 'children'> {
  titleChannel?: string
  posterUrl?: string
  titleProgram?: string
  programLabels?: ILabelGroupTemplate3Props['list']
  description?: string
  textForEmptyBlock?: string
  fallbackImageSize?: IFallbackImageProps['size']
  fallbackImageBackgroundColor?: IFallbackImageProps['background']
  fallbackImageColor?: IFallbackImageProps['color']
  onClickMore?: () => void
  locked?: boolean
  titleButtonMore?: string
}

export const InfoBlockEPG = ({
  titleChannel = '',
  posterUrl = '',
  titleProgram = '',
  programLabels,
  description = '',
  rowGap = DescriptionRowGap.INDENT_60,
  textForEmptyBlock = '',
  fallbackImageSize,
  fallbackImageColor,
  fallbackImageBackgroundColor,
  onClickMore,
  locked,
  titleButtonMore,
  ...rest
}: IInfoBlockEPG): JSX.Element => {
  const conditionDescription = (titleProgram || description) && !locked
  const emptyBlockTitle = locked ? '' : textForEmptyBlock
  const clientWidth = useClientWidth()
  const maxLineTitle = getValueForBreakpoint(
    clientWidth,
    infoBlockEPGDescriptionTitle
  )
  const maxLineMore = getValueForBreakpoint(
    clientWidth,
    infoBlockEPGDescriptionBlockMore
  )

  return (
    <Description rowGap={rowGap} {...rest}>
      <TextBlockWithLogo
        title={titleChannel}
        posterUrl={posterUrl}
        fallbackImageBackgroundColor={fallbackImageBackgroundColor}
        fallbackImageColor={fallbackImageColor}
        fallbackImageSize={fallbackImageSize}
        locked={locked}
      />
      {conditionDescription && (
        <InfoBlockDescriptionSC>
          <TextBoxMaxLine1FontLgBold
            maxLines={maxLineTitle}
            title={titleProgram}
          />
          <LabelGroupTemplate3 list={programLabels} />
          <TextBlockWithMore
            description={description}
            stars={''}
            directors={''}
            maxLines={maxLineMore}
            onClickMore={onClickMore}
            titleButton={titleButtonMore}
          />
        </InfoBlockDescriptionSC>
      )}
      {!conditionDescription && <TextBoxBody3Disable title={emptyBlockTitle} />}
    </Description>
  )
}
